import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const get = async (data: { date: any; pieDate: any }) => {
  return httpRequest.get(`/api/product/dashboard`, data);
};
